/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { classNames } from '@ember-decorators/component';
import { action, computed } from '@ember/object';
import { gte } from '@ember/object/computed';
import Editor from 'cio/components/action-composer/base/editor';
import { isBlank } from '@ember/utils';
import { EMPTY_BODY_METHODS, HTTP_VERBS } from 'cio/utils/composer/webhooks';
import { addNewHeader, removeHeader, updateHeaderName, updateHeaderValue } from 'cio/utils/models/header';
import { getLiquidToInsert } from 'cio/utils/liquid';

@classNames('action-composer-panel', 'action-composer-panel--editor')
export default class WebhookEditor extends Editor {
  httpVerbs = HTTP_VERBS;

  get disableEditing() {
    return this.auth.redacted;
  }

  @gte('editableEntity.template.headers.length', 4)
  hasMaximumHeaders;

  @computed('editableEntity.template.url')
  get urlIsBlank() {
    return isBlank(this.get('editableEntity.template.url'));
  }

  @computed('errors.headers.[]')
  get headerErrors() {
    return this.get('errors.headers') || [];
  }

  @computed('editableEntity.template.requestMethod')
  get isEmptyBodyMethod() {
    return EMPTY_BODY_METHODS.includes(this.get('editableEntity.template.requestMethod'));
  }

  @action
  insertLiquid([fieldName, index], liquid, fallback) {
    let fieldNameToSelector = {
      'template.url': '.js-editor-field-url input',
      'header.name': '.js-editor-field-header-name input',
      'header.value': '.js-editor-field-header-value input',
    };
    let selector = fieldNameToSelector[fieldName];

    if (!selector) {
      return;
    }

    let elem = this.element.querySelectorAll(selector)[index];
    let { selectionStart, selectionEnd, value } = elem;
    let beginStr = value.substr(0, selectionStart);
    let endStr = value.substr(selectionEnd, value.length);
    let liquidToInsert = getLiquidToInsert(liquid, fallback, this.editableEntity.template.templateEngine);

    elem.value = `${beginStr}${liquidToInsert}${endStr}`;
    elem.dispatchEvent(new Event('input', { bubbles: true }));
  }

  @action
  addHeader() {
    let { template } = this.editableEntity;
    template.headers = addNewHeader(template.headers);
  }

  @action
  removeHeader(index) {
    let { template } = this.editableEntity;
    template.headers = removeHeader(template.headers, index);
  }

  @action
  updateHeaderName(index, event) {
    let { template } = this.editableEntity;
    template.headers = updateHeaderName(template.headers, index, event.target.value);
  }

  @action
  updateHeaderValue(index, event) {
    let { template } = this.editableEntity;
    template.headers = updateHeaderValue(template.headers, index, event.target.value);
  }

  @action
  trimUrl(evt) {
    this.set('editableEntity.template.url', evt.target.value.trim());
  }
}
